import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { NoIndex } from "../components/Seo";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background grid place-items-center px-6">
      <NoIndex title="Payment" />
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-sm w-full text-center bg-card border border-border rounded-2xl p-8"
        data-testid="payment-cancel-page"
      >
        <XCircle className="h-10 w-10 text-muted-foreground mx-auto" />
        <h1 className="mt-4 font-serif text-2xl">Checkout cancelled</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          No charge was made. You can upgrade anytime.
        </p>
        <div className="mt-6 flex gap-2">
          <Button onClick={() => navigate("/pricing")} className="flex-1 bg-primary hover:bg-primary/90">
            View plans
          </Button>
          <Button onClick={() => navigate("/vault")} variant="outline" className="flex-1">
            My vault
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
